import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { XCircle, Home } from 'lucide-react';

interface ShareDeclinedCardProps {
  onGoHome: () => void;
}

export function ShareDeclinedCard({ onGoHome }: ShareDeclinedCardProps) {
  useLanguage();
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, ease: 'easeOut' }}
      className="w-full bg-white rounded-2xl shadow-[0_10px_40px_rgba(0,0,0,0.08)] overflow-hidden"
    >
      <div className="p-8 sm:p-10 text-center">
        {/* Icon */}
        <div className="w-16 h-16 rounded-2xl bg-slate-100 flex items-center justify-center mx-auto mb-5">
          <XCircle className="w-8 h-8 text-slate-500" />
        </div>

        {/* Title */}
        <h1 className="text-xl sm:text-2xl font-bold text-foreground mb-2">
          {translateInterfaceText("Você recusou o compartilhamento")}</h1>
        <p className="text-sm text-muted-foreground max-w-sm mx-auto">
          {translateInterfaceText("Nenhuma alteração foi feita em sua conta.")}</p>
      </div>

      {/* CTA */}
      <div className="px-8 sm:px-10 pb-8 sm:pb-10">
        <Button
          onClick={onGoHome}
          className="w-full h-12 bg-[#4B7BFF] hover:bg-[#3B6BEF] text-white font-medium"
        >
          <Home className="w-4 h-4 mr-2" />
          {translateInterfaceText("Voltar para HostVSL")}</Button>
      </div>
    </motion.div>
  );
}
